import { DialogTitle, FormControl, FormControlLabel, FormLabel, IconButton, Radio, RadioGroup } from '@mui/material'
import { SubmitButton } from 'components/common/buttons/SubmitButton';
import MuiCustomModal from 'components/common/MuiCustomModal'
import SelectInterperter from 'components/common/SelectInterperter';
import React, { useEffect, useState } from 'react'
import toast from 'react-hot-toast';
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { setActionAssign } from 'slices/actionButtonSlice';
import { addInviteInterpreters } from 'slices/inviteInterpreterSlice';
import Swal from 'sweetalert2';

const AfterAppointmentModal = ({
    item,
    show,
    handleClose,
    callback
}) => {
    const [state, setState] = useState(item?.type == "OPI On Demand" ? "call_inivite" : "auto_inivite");
    const [interpreter, setInterpreter] = useState("");
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const [loading, setLoading] = useState(false)

    useEffect(() => {
        setState(item?.type == "OPI On Demand" ? "call_inivite" : "auto_inivite")
    }, [item?.type])


    const handleChange = (e) => {
        // Call the callback function with the selected option
        console.log("selected option", e.target.value)
        setState(e.target.value)
    }


    const redirectToPage = () => {
        handleClose()
        callback && callback()
        navigate(`/appointments/invite-interpreter/${item?.id}`, { replace: true });
    }

    const handleSubmit = () => {

        const callBack = (success, message) => {
            if (success) {
                // toast.success(message, {
                //     className: "successToast",
                // })
                handleClose()
                setLoading(false);


                Swal.fire({
                    title: "Success!",
                    text: message,
                    icon: "success",
                    timer: 2000,
                    showConfirmButton: false
                }).then(() => {
                    redirectToPage()
                })


            } else {
                toast.error(message, {
                    className: "errorToast",
                })
                setLoading(false);
            }
        }
        setLoading(true);
        if (state === "invite_interpreter") {
            const interpreter_ids = interpreter?.interpreter_id?.map(i => i?.value)
            interpreter_ids?.length > 0 && dispatch(addInviteInterpreters({ interpreter_ids, }, item?.id, callBack))

        }
        else if (state === "call_inivite") {
            dispatch(
                setActionAssign(
                    item?.id,
                    interpreter,
                    "auto-invite-by-call",
                    callBack
                )
            )
        }
        else if (state === "auto_inivite") {
            dispatch(
                setActionAssign(
                    item?.id,
                    interpreter,
                    "auto-invite-by-email",
                    callBack
                )
            )
        }
        else {
            setLoading(false);
        }

    }

    return (

        <MuiCustomModal
            fullWidth={true}
            maxWidth={"md"}
            aria-labelledby="customized-dialog-title"
            open={show}
            sx={{
                '& .MuiDialog-container': {
                    alignItems: "center",
                },
                '& .MuiPaper-root': {
                    overflowY: "visible",

                },
            }}
        >


            <div className="modal-content full_modal">
                <div className="modal-header header_modal align-items-center">

                    <DialogTitle>
                        <h5 className="modal-title_u">Taken Action {item?.appid}</h5>
                        <IconButton
                            aria-label="close"
                            onClick={handleClose}
                            sx={(theme) => ({
                                position: 'absolute',
                                right: 8,
                                top: 8,
                                color: theme.palette.grey[500],
                            })}
                        >
                            <button type="button" className="btn-close" aria-label="Close"></button>
                        </IconButton>
                    </DialogTitle>
                </div>
                <div className="modal-body modal_form_body">


                    <FormControl sx={{ width: "100%" }}>
                        <RadioGroup
                            aria-labelledby="demo-radio-buttons-group-label"
                            defaultValue={item?.type == "OPI On Demand" ? "call_inivite" : "auto_inivite"}
                            name="radio-buttons-group"
                            onChange={handleChange}
                        >
                            {item?.type == "OPI On Demand" && <FormControlLabel value="call_inivite" control={<Radio />} label="Initiate Call Invite" />}
                            <FormControlLabel value="auto_inivite" control={<Radio />} label="Auto invite interpreters" />
                            <FormControlLabel value="invite_interpreter" control={<Radio />} label="Select Interpreters to invite" />
                            {/* <FormControlLabel value="redirect" control={<Radio />} label="Take to invite interpreters page" /> */}
                        </RadioGroup>
                    </FormControl>


                    {state === "invite_interpreter" &&
                        <div className="form-group" style={{ marginTop: 0 }}>
                            <SelectInterperter setInterpreter={setInterpreter} exclude_interpreter={item?.exclude_interpreter} />
                        </div>
                    }


                    <div className="row-primary mt-3">
                        <SubmitButton loader={loading} btnText="Submit" handleSubmit={handleSubmit} />
                        <div className="row-primary" style={{ marginLeft: "auto" }}>
                            <SubmitButton className="darkGrey" btnText="Redirect to Invite Interpreter" handleSubmit={redirectToPage} />

                            <SubmitButton className="lightGrey" btnText="Cancel" handleSubmit={handleClose} />
                        </div>
                    </div>


                </div>
            </div>

        </MuiCustomModal>

    )
}

export default AfterAppointmentModal